import type { DraggableProvided } from 'react-beautiful-dnd';

import { DragHandleIcon } from '@shopify/polaris-icons';
import { WrapperAction } from './WrapperAction';
import { Icon } from '@shopify/polaris';

interface DragActionProps {
  draggable?: {
    provided: DraggableProvided;
  };
}

export const DragAction: React.FC<DragActionProps> = ({ draggable }) => {
  if (!draggable) return;

  const { provided } = draggable;

  return (
    <WrapperAction {...provided.dragHandleProps} onClick={(e) => e.stopPropagation()}>
      <Icon source={DragHandleIcon} />
    </WrapperAction>
  );
};
